var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionCurrentPosition(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -2453.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Current-position",
    transform: "translate(445.000000, 2453.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 L18,3.169 C23.574,4.033 27.968,8.426 28.83,14 L28.83,14 L32,14 L32,18 L28.83,18 C27.968,23.574 23.574,27.968 18,28.83 L18,28.83 L18,32 L14,32 L14,28.83 C8.426,27.968 4.033,23.574 3.169,18 L3.169,18 L0,18 L0,14 L3.169,14 C4.033,8.426 8.426,4.033 14,3.169 L14,3.169 L14,0 L18,0 Z M16,6 C10.486,6 6,10.486 6,16 C6,21.514 10.486,26 16,26 C21.514,26 26,21.514 26,16 C26,10.486 21.514,6 16,6 Z M16,10 C19.313,10 22,12.687 22,16 C22,19.313 19.313,22 16,22 C12.687,22 10,19.313 10,16 C10,12.687 12.687,10 16,10 Z",
    id: 174
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionCurrentPosition);
export default __webpack_public_path__ + "static/media/navigation-and-action-current-position.fabc3dfa.svg";
export { ForwardRef as ReactComponent };